"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const request_1 = __importDefault(require("./request"));
class PeliasProvider {
    constructor({ apiKey, locationType, baseUrl }) {
        this.apiKey = apiKey;
        this.locationType = locationType;
        this.baseUrl = baseUrl;
    }
    geocode(term) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = new request_1.default({ apiKey: this.apiKey, locationType: this.locationType, baseUrl: this.baseUrl });
            return request.autocomplete(term);
        });
    }
    reverseGeocode(latitude, longitude) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = new request_1.default({
                apiKey: this.apiKey,
                locationType: "locality,localadmin,borough,macrohood,postalcode,county",
                limit: "1",
                baseUrl: this.baseUrl,
            });
            const [result] = yield request.reverseGeocode(latitude, longitude);
            return result;
        });
    }
    resultSelected(autoCompletedResult) {
        return __awaiter(this, void 0, void 0, function* () {
            return Promise.resolve(autoCompletedResult);
        });
    }
}
exports.default = PeliasProvider;
